export const getTextInputContainerStyles = () => ({
  TextInputContainer: {
    width: '435px',
    '& div .error': {
      color: '#A80000',
    },
  },
});
